import * as React from 'react';
import { ReferenceData, ReferenceDescriptions, ReferenceLanguage } from 'src/utils/reference-schema';
const ReferenceDataContext = React.createContext<ReferenceData | null>(null);
const ReferenceDescriptionsContext = React.createContext<ReferenceDescriptions | null>(null);
interface ReferenceDataProviderProps {
  children?: React.ReactNode;
  value: ReferenceData;
}
interface ReferenceDescriptionsProviderProps {
  children?: React.ReactNode;
  value: ReferenceDescriptions;
}
export const ReferenceDataProvider = (props: ReferenceDataProviderProps) => <ReferenceDataContext.Provider {...props} data-sentry-element="ReferenceDataContext.Provider" data-sentry-component="ReferenceDataProvider" data-sentry-source-file="reference-data-provider.tsx" />;
export const ReferenceDescriptionsProvider = (props: ReferenceDescriptionsProviderProps) => <ReferenceDescriptionsContext.Provider {...props} data-sentry-element="ReferenceDescriptionsContext.Provider" data-sentry-component="ReferenceDescriptionsProvider" data-sentry-source-file="reference-data-provider.tsx" />;
export const useReferenceData = (language: string) => {
  const referenceData = React.useContext(ReferenceDataContext);
  if (!referenceData) {
    throw new TypeError('useReferenceData must be called from within a `ReferenceDataProvider`.');
  }
  if (!(language in referenceData)) {
    throw new TypeError(`Invalid API Reference language "${language}"`);
  }

  // Introducing lint rule banning type assertions
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  return referenceData[language as ReferenceLanguage];
};
export const useReferenceDescriptions = () => {
  const referenceDescriptions = React.useContext(ReferenceDescriptionsContext);
  if (!referenceDescriptions) {
    throw new TypeError('useReferenceDescriptions must be called from within a `ReferenceDescriptionsProvider`.');
  }
  return referenceDescriptions;
};